<template>
  <div class="stacked-wrapper">
    <div class="contentSection text-center">
      <h2>
        <strong>Top Companies are hiring in your area!</strong>
      </h2>
      <div class="col-md-12 mb-4">
        <img src="@/assets/imgs/top-companies-logos.png" alt>
      </div>
      <div class="row mt-4">
        <div class="col-md-6 text-right">
          <input
            style
            class="greenBtn hidden"
            v-model="offer.linkOutButtonText"
            type="text"
            required
          >
        </div>
        <div class="col-md-6 text-left">
          <input style class="greyBtn hidden" v-model="offer.nextButtonText" type="text" required>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    offer: { type: Object, required: true }
  }
}
</script>
<style lang="scss" scoped>
</style>
